"use client";
import React, { useState } from "react";
import moment from "moment";

import BlogSearch from "./blog-search";
import FeaturedBlogs from "./featured-blogs";
import blogsData from "@/data/blogs.json";
import { BlogMomentDateFormat } from "@/pages/blog";
import OtherBlogs from "./other-blogs";
import classes from "@/styles/blog/blog-main.module.css";

const BlogContainer = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const allBlogs = blogsData
    .map((blog) => {
      // the json blog images should be hosted on azure portal or somewhere else
      // so local URL and image URL are both remote
      const momentDate = moment(blog.date);
      return {
        ...blog,
        author: "ShipVista",
        imageURL: blog.localImageURL,
        momentDate: momentDate,
        date: momentDate.isValid()
          ? momentDate.format(BlogMomentDateFormat)
          : blog.date,
      };
    })
    .sort((a, b) => {
      const aMoment = a?.momentDate;
      const bMoment = b?.momentDate;

      if (aMoment.isValid() && bMoment.isValid()) {
        return bMoment.diff(aMoment);
      } else {
        return 1;
      }
    });

  const featuredArticles = allBlogs
    .filter((article) => article.imageURL)
    .slice(0, 3);

  return (
    <>
      <BlogSearch
        classes={classes}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {!searchTerm && (
        <FeaturedBlogs classes={classes} featuredArticles={featuredArticles} />
      )}
      <OtherBlogs
        classes={classes}
        articles={allBlogs}
        searchTerm={searchTerm}
      />
    </>
  );
};

export default BlogContainer;
